import {
  isExitCommandInput,
  getCancelledOutput,
} from "../../utils/command/commandLineUtils";
import useCommandFlowStore from "../../store/commandFlowStore";
import { getTranslationFunction } from "../../utils/core/translationUtils";
import { clearAllCommandState } from "../../utils/command/commandStateUtils";

// Handles exit command input in session using setters object
export async function handleExitCommandWithSetters({
  trimmed,
  currentPrompt,
  setters,
  engine,
  onCommandAbort,
  activeCommandName,
}) {
  if (isExitCommandInput(trimmed)) {
    const setOutput = useCommandFlowStore.getState().setOutput;
    const addOutputWithTypingEffect =
      useCommandFlowStore.getState().addOutputWithTypingEffect;
    const currentOutput = useCommandFlowStore.getState().output;
    const t = getTranslationFunction();

    // Capture session data BEFORE clearAllCommandState wipes it
    const sessionDataSnapshot =
      useCommandFlowStore.getState().sessionData ?? {};

    // Add the prompt + input line immediately with proper colors (no typing effect)
    const promptWithInputLine = {
      type: "output",
      text: [
        { text: currentPrompt ? currentPrompt.trimEnd() : "", color: "output" },
        { text: " ", color: null },
        { text: trimmed, color: "input" },
      ],
    };
    setOutput([...currentOutput, promptWithInputLine]);

    // Add only the cancellation message with typing effect
    const cancelMessage = t("commandCancelled");
    const cancelOutputLines = [{ type: "output", text: cancelMessage }];

    await addOutputWithTypingEffect(cancelOutputLines);

    // If frame mode was active, end it and clear the terminal
    const { frameMode, endFrameMode, setWasCleared } =
      useCommandFlowStore.getState();
    if (frameMode) {
      endFrameMode();
      setOutput([]);
      setWasCleared(true);
      setTimeout(() => useCommandFlowStore.getState().setWasCleared(false), 100);
    }

    // Clear all command-related state using the centralized utility
    clearAllCommandState();

    // Also reset the setters for compatibility
    setters.setCurrentPrompt(null);

    // Clear engine state
    if (engine) {
      engine.sessionManager.endSession();
    }

    // Fire abort callback after state cleanup so consumers see consistent state
    if (onCommandAbort && activeCommandName) {
      try {
        onCommandAbort(activeCommandName, sessionDataSnapshot);
      } catch (err) {
        console.error("onCommandAbort threw:", err);
      }
    }

    return true;
  }
  return false;
}
